// extracted by mini-css-extract-plugin
export default {"player":"W_DTH","player-loading":"_2teeE","playerLoading":"_2teeE"};